<template>
  <v-dialog v-model="cDialog" width="500">
    <v-card>
      <validation-observer v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <v-card-title class="headline grey lighten-2" primary-title
            >Change password</v-card-title
          >
          <v-card-text>
            <v-container>
              <warning :messages="messages"></warning>
              <v-row>
                <v-col>
                  <validation-provider
                    :vid="uuid()"
                    name="Password"
                    rules="required|min:6|max:16"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="Password"
                      type="password"
                      v-model="password"
                    ></v-text-field>
                    <span class="validation-message">{{ errors[0] }}</span>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <validation-provider
                    :vid="uuid()"
                    name="New Passowrd"
                    rules="required|password:@Confirm|min:6|max:16"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="New Password"
                      type="password"
                      v-model="newPassword"
                    ></v-text-field>
                    <span class="validation-message">{{ errors[0] }}</span>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <validation-provider
                    name="Confirm"
                    rules="required|min:6|max:16"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="Confirm"
                      type="password"
                      v-model="confirmPassword"
                    ></v-text-field>
                    <span class="validation-message">{{ errors[0] }}</span>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text type="submit">OK</v-btn>
          </v-card-actions>
        </form>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import uuid from "src/mixins/uuid";
import validationRules from "src/mixins/validationRules";
import http from "src/util/http";
import Warning from "src/components/common/Warning";

export default {
  components: { ValidationObserver, ValidationProvider, Warning },
  props: ["dialog", "type"],
  mixins: [uuid, validationRules],
  data() {
    return {
      cDialog: this.dialog,
      password: "",
      newPassword: "",
      confirmPassword: "",
      messages: [],
    };
  },
  watch: {
    dialog(newValue) {
      if (newValue !== this.cDialog) {
        this.cDialog = newValue;
      }
    },
    cDialog(newValue) {
      this.$emit("update:dialog", newValue);

      this.pou = {
        type: this.type,
      };
    },
  },
  methods: {
    async submit() {
      try {
        await http().post("change-password", {
          email: localStorage.getItem("email"),
          password: this.password,
          newPassword: this.newPassword,
        });

        this.cDialog = false;
        localStorage.removeItem("authen-token");
        this.$router.push({ name: "Login" });
      } catch (err) {
        this.messages = ["Password incorrect"];
      }
    },
  },
};
</script>
